import { render } from "./BackgroundRain.vue?vue&type=template&id=95d86066&scoped=true"
import script from "./BackgroundRain.vue?vue&type=script&lang=js"
export * from "./BackgroundRain.vue?vue&type=script&lang=js"

import "./BackgroundRain.vue?vue&type=style&index=0&id=95d86066&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95d86066"]])

export default __exports__